import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "tailwindcss/tailwind.css";
import { BASE_URL } from "../../config";
import { motion } from "framer-motion";

const RVU_VALUE_INPUT_PATTERN = /^\d{0,16}(?:\.\d{0,2})?$/;
const RVU_VALUE_PATTERN = /^(?:\d{1,16}(?:\.\d{1,2})?|\.\d{1,2})$/;

const AddRvu = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    rvu_category: "",
    rvu_code: "",
    rvu_description: "",
    value: "",
  });
  const [errors, setErrors] = useState({});

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "value" && !RVU_VALUE_INPUT_PATTERN.test(value)) return;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.rvu_code) newErrors.rvu_code = "RVU code is required.";
    if (!RVU_VALUE_PATTERN.test(formData.value) || Number(formData.value) <= 0) {
      newErrors.value =
        "RVU value must be greater than 0 with up to 16 whole-number digits and 2 decimal places.";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      Object.values(formErrors).forEach((error) => toast.error(error, { autoClose: 3000 }));
      return;
    }
    try {
      await axios.post(
        `${BASE_URL}/rvu`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
          },
        }
      );
      toast.success("RVU code created successfully.", { autoClose: 3000 });
      setTimeout(() => navigate("/rvu"), 2000);
    } catch (error) {
      if (error.response?.status === 422 && error.response?.data?.message) {
        if (typeof error.response.data.message === "string") {
          toast.error(error.response.data.message, { autoClose: 3000 });
        } else {
          Object.values(error.response.data.message).forEach((messages) => {
            const messageArray = Array.isArray(messages) ? messages : [messages];
            messageArray.forEach((message) => toast.error(message, { autoClose: 3000 }));
          });
        }
      } else {
        toast.error("Failed to create RVU code.", { autoClose: 3000 });
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-2 px-2 sm:px-6 lg:px-8">
      <ToastContainer position="top-right" autoClose={3000} />
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-3xl mx-auto"
      >
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Add New RVU Code</h1>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">RVU Category</label>
                <input
                  type="text"
                  name="rvu_category"
                  value={formData.rvu_category}
                  onChange={handleFormChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">RVU Code *</label>
                <input
                  type="text"
                  name="rvu_code"
                  value={formData.rvu_code}
                  onChange={handleFormChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                />
                {errors.rvu_code && <p className="mt-1 text-sm text-red-600">{errors.rvu_code}</p>}
              </div>
              {/* <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-gray-700">RVU Description</label>
                <input
                  type="text"
                  name="rvu_description"
                  value={formData.rvu_description}
                  onChange={handleFormChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                />
              </div> */}

              <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-gray-700">RVU Description</label>
                <textarea
                    name="rvu_description"
                    value={formData.rvu_description}
                    onChange={handleFormChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                    rows={4} // You can adjust the number of rows as needed
                />
                </div>


              <div>
                <label className="block text-sm font-medium text-gray-700">Value *</label>
                <input
                  type="text"
                  name="value"
                  value={formData.value}
                  onChange={handleFormChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm"
                  inputMode="decimal"
                  maxLength={19}
                />
                {errors.value && <p className="mt-1 text-sm text-red-600">{errors.value}</p>}
              </div>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                type="submit"
                className="bg-green-600 text-white px-4 py-2 rounded-md text-sm hover:bg-green-700"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default AddRvu;
